<template>
  <div class="text-center">
    <v-dialog
      v-if="$store.state.auth.checkAccess({key: 'bet_limits', value: true})"
      v-model="dialog"
      width="600"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          :color="(btn || {}).color || 'white'"
          :block="(btn || {}).block || true"
          :small="(btn || {}).small || true"
          :outlined="(btn || {}).small || true"
        >
          {{ (btn || {}).text || 'Bet Limits' }}
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          Bet Limits

          <v-spacer />
          <select-project
            v-if="!account.account_id"
            v-model="project"
            class="col-4 mt-3 game-controll-filter"
            style="max-width: 300px;"
            dense
          />
        </v-card-title>

        <v-card-text class="px-0 pb-0">

          <v-data-table
            class="col-12 mt-2 mb-0 ml-0 mr-0 pa-0"
            :loading="loading"
            :headers="headers"
            :items="items"
            :items-per-page="-1"
            hide-default-footer
            fixed-header
          >

            <template v-slot:footer="{ }">
              <v-divider v-if="newLimit" />
              <v-row v-if="newLimit" class="ma-0">
                <v-select
                  v-model="newLimit.type"
                  :items="types"
                  label="Type"
                  style="max-width: 200px;"
                  class="col-4"
                  hide-details
                />
                <v-text-field
                  label="Min"
                  v-model="newLimit.min"
                  small
                  hide-details
                  @keypress.enter=""
                  class="col-2"
                  :style="{width: '50px'}"
                />
                <v-text-field
                  label="Max"
                  v-model="newLimit.max"
                  small
                  hide-details
                  @keypress.enter=""
                  class="col-2"
                  :style="{width: '50px'}"
                />
                <v-icon @click="addLimit" title="Add Limit" class="mr-2">mdi-upload</v-icon>
                <v-icon @click="newLimit = false" class="mr-4">mdi-close</v-icon>
              </v-row>
            </template>
            <template v-slot:item.min="{ item }">
              <v-text-field
                v-if="editItems[item.type]"
                v-model="editItems[item.type].min"
                small
                hide-details
                class="mt-0 pb-0 pt-0 float-left"
                @keypress.enter=""
                :style="{width: '50px'}"
              />
              <v-text-field
                v-else
                v-model="item.min"
                small
                hide-details
                class="mt-0 pb-0 pt-0 float-left"
                @keypress.enter=""
                :style="{width: '50px'}"
                readonly
                disabled
              />
            </template>
            <template v-slot:item.max="{ item }">
              <v-text-field
                v-if="editItems[item.type]"
                v-model="editItems[item.type].max"
                small
                hide-details
                class="mt-0 pb-0 pt-0 float-left"
                @keypress.enter=""
                :style="{width: '50px'}"
              />
              <v-text-field
                v-else
                v-model="item.max"
                small
                hide-details
                class="mt-0 pb-0 pt-0 float-left"
                @keypress.enter=""
                :style="{width: '50px'}"
                readonly
                disabled
              />
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon class="float-right" @click="toggleEdit(item)">{{ !editItems[item.type] ? 'mdi-pencil' : 'mdi-close' }}</v-icon>
              <v-icon class="float-right mr-3" @click="deleteItem(item)">delete</v-icon>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>

          <v-btn
            color="primary"
            text
            @click="save('all')"
          >
            Save
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="types.length == 0"
            @click="initAddLimit()"
          >
            Add
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="handler"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'
  import { map, clone, cloneDeep, find, remove } from 'lodash'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    components: { SelectProject },
    props: [ 'btn', 'account' ],

    data: () => ({
      project: '',
      dialog: false,
      loading: false,
      editItems: {},
      newLimit: false,
      items: [],
      types: [],
      brands: [],
      systems: [],
      headers: [
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Min', value: 'min', sortable: false },
        { text: 'Max', value: 'max', sortable: false },
        { text: '', value: 'action', sortable: false },
      ],

    }),
    computed: {
      projectList: function () {
        return map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id, licence: i.licence }))
      },
      ...mapGetters({ activeAccount: 'account/active', history: 'account/loginHistory' }),
    },

    watch: {
      dialog (val) {
        if (!this.account) this.account = {}
        // this.projectList[0];
        this.project = (this.account.login ? this.$store.state.auth.getEntityByLogin(this.account.login).entity_id : null) || this.projectList[0].value

        if (this.account.account_id) {
          this.newLimit = false
          this.loadTypes()
          this.loadConfig()
        }
      },
      project (val) {
        if (this.dialog && !this.account.account_id) {
          this.newLimit = false
          this.loadTypes()
          this.loadConfig()
        }
      }
    },

    methods: {

      toggleEdit (item) {
        item.edit = !item.edit
        if (!item.edit) {
          item.min = clone(item.init.min)
          item.max = clone(item.init.max)

          delete this.editItems[item.type.toString()]
        } else {
          if (!item.init) {
            item.init = cloneDeep(item)
          }
          this.editItems[item.type] = item
        }

        this.editItems = cloneDeep(this.editItems)
      },
      handler: function (event) {
        this.dialog = false
      },
      initAddLimit: function () {
        this.newLimit = { type: 'default', min: 0, max: 0, edit: false, new: true }
      },
      addLimit: function () {
        if (find(this.items, (o) => o.type == this.newLimit.type)) {
          this.$notification.show = true
          this.$notification.message = 'This type already exist'
          this.$notification.type = 'warning'
          return
        }

        this.save(this.newLimit).then(() => {
          this.newLimit.init = clone(this.newLimit)
          this.items.push(this.newLimit)
          this.editItems[this.newLimit.type] = this.newLimit
          this.newLimit = false
        })
      },
      save: async function (item) {
        if (await this.$root.$confirm('Confirm', item == 'all' ? 'Save all changes' : 'Add new limit')) {
          let toUpdate = []
          if (item == 'all') {
            toUpdate = Object.values(this.editItems)
          } else {
            toUpdate = [ item ]
          }

          API.call('/$v/game/bet_limits_update.json', {
            limits: toUpdate,
            account_id: this.account.account_id
          }, null, this.project).then(resp => {
            this.$notification.show = true
            this.$notification.message = 'Limits updated'
            this.$notification.type = 'success'
          }).catch(e => {
          })

        }
      },
      deleteItem: async function (item) {
        if (await this.$root.$confirm('Confirm', 'Are you sure you want to delete this item?')) {
          API.call('/$v/game/bet_limits_update.json', {
            type: item.type,
            delete: true,
            account_id: this.account.account_id
          }, null, this.project).then(resp => {
            if (resp.data.deleted) {
              remove(this.items, (o) => o.type == item.type)
              this.items = cloneDeep(this.items)

              this.$notification.show = true
              this.$notification.message = 'Limit removed'
              this.$notification.type = 'success'
            }

          }).catch(e => {
          })

        }
      },
      loadTypes () {
        this.loading = true
        let entity_id = this.project

        return API.call('/$v/game/list.json', {
          entity_id,
          all: true,
          wo_games: true,
        }).then(resp => {
          this.types = resp.types
          this.systems = resp.systems
          this.brands = resp.brands
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },
      loadConfig () {
        this.loading = true
        let entity_id = this.project

        return API.call('/$v/game/bet_limits.json', {
          entity_id,
          account_id: this.account.account_id
        }, null, entity_id).then(resp => {
          this.items = resp.data
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },
    }

  }
</script>
